import { boot } from './common.js';
import { productCard } from '../ui/card.js';
import { mountTabs } from '../ui/tabs.js';
import { BEST, NEW, HOME_TABS } from '../lib/collections.js';

const { C, rails } = boot();
const card = (p) => productCard(p, { url: C.url });
const $ = (id) => document.getElementById(id);
// the build already rendered the rails and the first tab into the page (crawlers follow those links);
// fill them here only if they came empty
const fill = (el, list) => { if (!el.querySelector('.card:not(.sk)')) el.innerHTML = list.map(card).join(''); };

fill($('railBest'), BEST.map(i => C.byId[i]));
fill($('railNew'), NEW.map(i => C.byId[i]));
rails();

const grid = $('tabGrid'), viewAll = document.querySelector('#browse .viewall a');
let first = true;
const showTab = (k) => {
  if (viewAll) viewAll.href = HOME_TABS[k].more;
  if (first && k === 'best') { first = false; return fill(grid, HOME_TABS.best.items(C)); }
  first = false;
  grid.classList.add('swap');
  requestAnimationFrame(() => { grid.innerHTML = HOME_TABS[k].items(C).map(card).join(''); grid.classList.remove('swap'); });
};
mountTabs(document.querySelector('[data-tabs]'), { onSelect: showTab }).select('best');

// marquee: duplicate content for a seamless loop (the copy is hidden from screen readers)
const track = $('track');
if (track) track.insertAdjacentHTML('beforeend', `<span class="dup" aria-hidden="true">${track.innerHTML}</span>`);
